// extracted by mini-css-extract-plugin
module.exports = {"tableActionCell":"TableActionCell_tableActionCell__1hNb0"};